import { useUpdateDatasetInfo } from 'api/api-hooks/datasets-hooks';
import { BaseDatasetDTO } from 'api/model/dataset/BaseDatasetDTO';
import { GroupButtonProps } from 'api/model/dataset/datasetGroups'
import { easasAlert } from 'components/fragments/easas-global-fragment/EasasGlobalAlerts';
import { Button } from 'primereact/button';
import React from 'react'

type SetGroupButtonProps = GroupButtonProps & {
  selectedDatasets: BaseDatasetDTO[];
  closeDialog: () => void;
};

const SetGroupButton: React.FC<SetGroupButtonProps> = ({
  group,
  selectedDatasets,
  closeDialog,
}) => {
  const { mutateAsync } = useUpdateDatasetInfo();

  const handleSetGroup = async () => {
    const results = await Promise.allSettled(
      selectedDatasets.map(async dataset => {
        return mutateAsync({ ...dataset, groupId: group?.id! });
      })
    );

    const successFullMutations = results.filter(result => result.status === "fulfilled");
    const failedMutations = results.filter(result => result.status === "rejected");

    if (successFullMutations.length === results.length) {
      easasAlert({
        summary: "Success",
        detail: "All changes were saved successfully.",
        severity: "success",
      });
    } else {
      easasAlert({
        summary: "Error",
        detail: `${failedMutations.length} datasets failed to update`,
        severity: "error",
      });
    }
    closeDialog();
  };

  return (
    <div className='flex align-items-center gap-3'>
      <Button label="Set group" onClick={handleSetGroup} />
      <p>{selectedDatasets.length} dataset(s) will be affected.</p>
    </div>
  );
};

export default SetGroupButton